import { gql } from '__generated__';

export default gql(`
  query GetExports($project_id: ID!) {
    session {
      id
      user {
        id
        recent_exports(project_id: $project_id) {
          ...ExportFields
        }
      }
    }
    project(id: $project_id) {
      id
      mailchimp_exports {
        ...ExportFields
      }
      export_profiles {
        id
        type
        title
        event {
          id
          title
        }
        created_at
      }
    }
  }

  fragment ExportFields on Export {
    id
    format
    title
    url
    progress
    failed
    finished
    generated_at
    created_at
  }
`);
